import * as LZString from "lz-string";

export function compress(data: string): string {
  return LZString.compressToBase64(data);
}

export function decompress(data: string): string {
  return LZString.decompressFromBase64(data);
}



// WEBPACK FOOTER //
// ./assets/js/compress.ts


// WEBPACK FOOTER //
// ./assets/js/compress.ts